import { Theme } from './types';

export function applyTheme(theme: Theme) {
    const root = document.documentElement;
    const semantic = theme.semantic;
    Object.entries(semantic).forEach(([key, value]) => {
        root.style.setProperty(`--color-${key}`, value);
    });

    root.style.setProperty('--color-primary', semantic.primary);
    root.style.setProperty('--color-primary-light', semantic.primaryLight);
    root.style.setProperty('--color-on-primary', semantic.onPrimary);
    root.style.setProperty('--color-primary-hover', semantic.primaryHover);
    root.style.setProperty(
        '--color-info-container-light',
        semantic.infoContainerLight
    );
    root.style.setProperty(
        '--color-success-container-light',
        semantic.successContainerLight
    );
    root.style.setProperty('--color-success-light', semantic.successLight);
    root.style.setProperty('--color-error-container', semantic.errorContainer);

    root.style.setProperty('--color-secondary', semantic.secondary);
    root.style.setProperty('--color-on-secondary', semantic.onSecondary);
    root.style.setProperty('--color-secondary-hover', semantic.secondaryHover);

    root.style.setProperty('--color-text-primary', semantic.textPrimary);

    root.style.setProperty(
        '--color-primary-container',
        semantic.primaryContainer
    );
    root.style.setProperty(
        '--color-primary-container-hover',
        semantic.primaryContainerHover
    );
    root.style.setProperty(
        '--color-on-primary-container',
        semantic.onPrimaryContainer
    );

    root.style.setProperty('--color-neutral', semantic.neutral);
    root.style.setProperty('--color-on-neutral', semantic.onNeutral);

    root.style.setProperty('--color-background', semantic.background);
    root.style.setProperty('--color-on-background', semantic.onBackground);

    root.style.setProperty('--color-surface', semantic.surface);
    root.style.setProperty('--color-on-surface', semantic.onSurface);

    root.style.setProperty('--color-error', semantic.error);
    root.style.setProperty('--color-on-error', semantic.onError);

    root.style.setProperty('--color-success', semantic.success);
    root.style.setProperty('--color-on-success', semantic.onSuccess);

    root.style.setProperty('--color-warning', semantic.warning);
    root.style.setProperty('--color-on-warning', semantic.onWarning);

    root.style.setProperty('--color-info', semantic.info);
    root.style.setProperty('--color-on-info', semantic.onInfo);

    root.style.setProperty('--color-divider', semantic.divider);
    root.style.setProperty('--color-skeleton', semantic.skeleton);

    root.style.setProperty('--color-disabled', semantic.disabled);
}
